import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCommonConfig } from "../../../../../redux/actions";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  dotNumberBlurValidation,
  dotNumberValidation,
  withDotValidation,
} from "../../../../../helpers/global_helper";
import ConfirmBetDeskonPopup from "../../../../Popups/ConfirmBetDeskonPopup";
import ErrorPopup from "../../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../../Popups/ErrorInnerPopup";
import SilangPopup from "./SilangPopup";
import CancelledBetDeskonPopup from "../../../../Popups/CancelledBetDeskonPopup";
import { withTranslation } from "react-i18next";
import { getUserBalance } from "../../../../../redux/actions";
import GameClosedPopup from "../../GameClosedPopup";
import MarketClose from "../../MarketClose";
import CommonBetHeader from "../../CommonBetHeader";

const Silang = (props) => {
  const dispatch = useDispatch();
  const device = useSelector((state) => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [submitPopup, setSubmitPopup] = useState(false);
  const [submitResult, setSubmitResult] = useState({});
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [totalBetAmount, setTotalBetAmount] = useState([]);
  const [bbPayAmount, setBBPayAmount] = useState(0);
  const [defaultValue, setDefaultValue] = useState("");

  const [inputs, setInputs] = useState({
    silangDepan: "",
    silangTengah: "",
    silangBelakang: "",
    homoDepan: "",
    homoTengah: "",
    homoBelakang: "",
  });

  const mainGroup = ["Silang", "Homo"];

  const keiArrayKeys = {
    "Silang-Depan": "kei_silang_depan",
    "Silang-Tengah": "kei_silang_tengah",
    "Silang-Belakang": "kei_silang_belakang",
    "Homo-Depan": "kei_homo_depan",
    "Homo-Tengah": "kei_homo_tengah",
    "Homo-Belakang": "kei_homo_belakang",
  };

  const initialMoData = [
    {
      gameName: "Silang",
      position: "Depan",
      numberInput: "",
      sendName: "Silang-Depan",
    },
    {
      gameName: "Silang",
      position: "Tengah",
      numberInput: "",
      sendName: "Silang-Tengah",
    },
    {
      gameName: "Silang",
      position: "Belakang",
      numberInput: "",
      sendName: "Silang-Belakang",
    },
    {
      gameName: "Homo",
      position: "Depan",
      numberInput: "",
      sendName: "Homo-Depan",
    },
    {
      gameName: "Homo",
      position: "Tengah",
      numberInput: "",
      sendName: "Homo-Tengah",
    },
    {
      gameName: "Homo",
      position: "Belakang",
      numberInput: "",
      sendName: "Homo-Belakang",
    },
  ];
  const [moData, setMoData] = useState(initialMoData);

  const closeSubmitPopup = () => {
    setSubmitPopup(false);
    handleReset();
  };

  const handleDeafultInputChange = (e) => {
    let { name, value } = e.target;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (value > betDiscount.showMax / 1000) {
      setErrorMessage(props.t("you_have_reached_max_bet_value"));
      setShowErrorPopup(true);
      return;
    }
    if (regex.test(value)) {
      setDefaultValue(value);
    }
  };

  const handleDeafultInputBlur = (e) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setDefaultValue(value);
    }
  };

  const handleNumberInputFocus = (index, e, keiKeys) => {
    if (defaultValue !== "" && defaultValue !== undefined) {
      setMoData((prev) => {
        let updateMoData = [...moData];
        updateMoData[index]["numberInput"] = defaultValue;
        return updateMoData;
      });
      calculateAmount(defaultValue, keiKeys, index);
    }
  };

  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
  };

  useEffect(() => {
    if (Object.keys(submitResult).length > 0) {
      setSubmitPopup(true);
    }
  }, [submitResult]);

  const handleInputChange = useCallback(
    (e) => {
      const { name, value } = e.target;
      const intValue = parseInt(value);
      let regex = '';
      if (String(betDiscount.showMin).length === 3) {
        regex = /^\d*([.,]\d?)?$/;
      } else {
        regex = /^\d*$/;
        value = withDotValidation(value);
      }
      if (value === "" || (regex.test(value) && !isNaN(intValue))) {
        setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
      }
      const minValue = betDiscount.showMin / 1000;
      const maxValue = betDiscount.showMax / 1000;
      if (intValue > maxValue) {
        setErrorMessage(props.t("you_have_reached_max_bet_value"));
        setShowErrorPopup(true);
        return;
      }
      setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
    },
    [betDiscount.showMin, betDiscount.showMax, props.t]
  );

  useEffect(() => {
    handleReset();
  }, [gameId]);

  const handleReset = () => {
    setMoData(initialMoData);
    setInputs({
      silangDepan: "",
      silangTengah: "",
      silangBelakang: "",
      homoDepan: "",
      homoTengah: "",
      homoBelakang: "",
    });
    setTotalBetAmount([]);
    setDefaultValue("");
  };

  const validate = () => {
    const minValue = betDiscount.showMin / 1000;
    const maxValue = betDiscount.showMax / 1000;
    let msg = "";
    Object.entries(inputs).map((val) => {
      if (val[1]) {
        // if (val[1] < minValue) {
        //   msg = `Minimal bet is ${minValue}`;
        //   return;
        // } else 
        if (val[1] > maxValue) {
          msg = `Your bet nominal exceeds the maximum limit.`;
          return;
        }
      }
    });
    return msg;
  };

  const submitProcess = async (event) => {
    const msg = await validate();
    if (msg) {
      setErrorMessage(msg);
      setShowErrorPopup(true);
    } else {
      // if (device === "Desktop") {
      //   const {
      //     silangDepan,
      //     silangTengah,
      //     silangBelakang,
      //     homoDepan,
      //     homoTengah,
      //     homoBelakang,
      //   } = inputs;

      //   if (
      //     silangDepan.trim() === "" &&
      //     silangTengah.trim() === "" &&
      //     silangBelakang.trim() === "" &&
      //     homoDepan.trim() === "" &&
      //     homoTengah.trim() === "" &&
      //     homoBelakang.trim() === ""
      //   ) {
      //     setErrorMessage(props.t("guess_bet_wrong"));
      //     setShowErrorPopup(true);
      //     return;
      //   }
      //   setShowConfirmationPopup(true);
      // } else {
      const hasEmptyNumberInput = moData.some(
        (item) => item.numberInput.trim() !== ""
      );

      if (!hasEmptyNumberInput) {
        setErrorMessage(props.t("guess_bet_wrong"));
        setShowErrorPopup(true);
        return;
      }
      setShowConfirmationPopup(true);
      // }
    }
  };
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const submitSilang = () => {
    // if (device === "Desktop") {
    //   setShowConfirmationPopup(false);
    //   const dataangka = [];
    //   const {
    //     silangDepan,
    //     silangTengah,
    //     silangBelakang,
    //     homoDepan,
    //     homoTengah,
    //     homoBelakang,
    //   } = inputs;

    //   const checkAndPush = (condition, label, value) => {
    //     if (condition) {
    //       dataangka.push([label, value * 1000, "success"]);
    //     } else {
    //       dataangka.push(["", "", "null"]);
    //     }
    //   };

    //   checkAndPush(
    //     silangDepan != 0 && silangDepan != "",
    //     "Silang-Depan",
    //     silangDepan
    //   );
    //   checkAndPush(
    //     silangTengah != 0 && silangTengah != "",
    //     "Silang-Tengah",
    //     silangTengah
    //   );
    //   checkAndPush(
    //     silangBelakang != 0 && silangBelakang != "",
    //     "Silang-Belakang",
    //     silangBelakang
    //   );
    //   checkAndPush(homoDepan != 0 && homoDepan != "", "Homo-Depan", homoDepan);
    //   checkAndPush(
    //     homoTengah != 0 && homoTengah != "",
    //     "Homo-Tengah",
    //     homoTengah
    //   );
    //   checkAndPush(
    //     homoBelakang != 0 && homoBelakang != "",
    //     "Homo-Belakang",
    //     homoBelakang
    //   );

    //   const data = {
    //     gameId: gameId,
    //     dataangka: dataangka,
    //     gameType: "silanghomo",
    //     action: "process",
    //     allowPartner: "allowPartner",
    //     betTogelAuth: "betTogelAuth",
    //   };

    //   makeAjax(url.TOGEL_API.processAltTogel, data).then((response) => {
    //     if (response.status !== respStatus["SUCCESS"]) {
    //       if (response.code === "sub_game_status_close") {
    //         setShowGameClose(true);
    //         showMessage(false);
    //         hideCommonToaster();
    //         dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
    //         return;
    //       }
    //       if (response.code === "market_close_err") {
    //         setShowMarketClose(true);
    //         showMessage(false);
    //         hideCommonToaster();
    //         dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
    //         return;
    //       }
    //       if (response.code !== "validation_error") {
    //         setErrorMessage(props.t(response.code));
    //         setShowErrorPopup(true);
    //         return;
    //       }
    //       showMessage("server error No data found", "error", "error");
    //       return;
    //     }
    //     setSubmitResult(response.data);
    //     dispatch(getUserBalance());
    //   });
    // } else {
    setShowConfirmationPopup(false);

    const dataangka = [];

    moData.forEach((item) => {
      if (item.numberInput.trim() !== "") {
        dataangka.push([item.sendName, item.numberInput * betDiscount.showMultiple, "success"]);
      } else {
        dataangka.push(["", "", "null"]);
      }
    });

    const data = {
      gameId: gameId,
      dataangka: dataangka,
      gameType: "silanghomo",
      action: "process",
      allowPartner: "allowPartner",
      betTogelAuth: "betTogelAuth",
    };

    makeAjax(url.TOGEL_API.processAltTogel, data).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          setErrorMessage(props.t(response.code));
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data found", "error", "error");
        return;
      }
      setSubmitResult(response.data);
      dispatch(getUserBalance());
    });
    // }
  };

  const handlegameNameChange = (index, event, field) => {
    const newValue = event.target.value;

    setMoData((prevState) => {
      const updatedMoData = [...prevState];

      if (field === "First") {
        updatedMoData[index].gameName = newValue;
      } else if (field === "Second") {
        updatedMoData[index].position = newValue;
      }

      updatedMoData[
        index
      ].sendName = `${updatedMoData[index].gameName}-${updatedMoData[index].position}`;

      return updatedMoData;
    });
  };

  const handleInputBlur = (index, event, keiKeys) => {
    let value = event.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    event.target.value = value;
    handleNumberInputChange(index, event, keiKeys);
  }

  const handleNumberInputChange = (index, event, keiKeys) => {
    let newValue = event.target.value;
    newValue = newValue.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      newValue = dotNumberValidation(newValue);
    } else {
      regex = /^\d*$/;
      newValue = withDotValidation(newValue);
    }
    const intValue = newValue;
    const minValue = betDiscount.showMin / 1000;
    const maxValue = betDiscount.showMax / 1000;

    // if (intValue < minValue) {
    //   setErrorMessage(`Minimal bet is ${minValue}`);
    //   setShowErrorPopup(true);
    //   return;
    // } else 
    if (intValue > maxValue) {
      setErrorMessage(props.t("you_have_reached_max_bet_value"));
      setShowErrorPopup(true);
      return;
    }
    
    console.log("newValue", newValue);
    
    if (newValue === "" || (regex.test(newValue) && !isNaN(intValue))) {
      setMoData((prevState) => {
        const updatedMoData = [...prevState];
        updatedMoData[index].numberInput = newValue;
        return updatedMoData;
      });
      calculateAmount(intValue, keiKeys, index);
    }
  };

  const calculateAmount = (intValue, keiKeys, index) => {
    console.log("intValue", intValue);
    
    let keiDiscount = betDiscount[keiKeys];
    let totalAmount = 0;
    let keiValue;
    if (
      intValue != null &&
      intValue != undefined &&
      intValue != "" &&
      !isNaN(intValue)
    ) {
      if (keiDiscount.toString().includes("-")) {
        keiValue =
          intValue * betDiscount.showMultiple -
          (intValue * betDiscount.showMultiple * keiDiscount) / 100;
        totalAmount = keiValue - (keiValue * betDiscount.showDisc) / 100;
      } else {
        keiValue = (intValue * betDiscount.showMultiple) * (betDiscount.showDisc / 100);
        totalAmount = intValue * betDiscount.showMultiple - keiValue;
      }
      totalAmount = parseFloat(totalAmount.toFixed(2));
    }

    setTotalBetAmount((prev) => {
      const updatetotalBet = [...prev];
      updatetotalBet[index] = parseFloat(totalAmount.toFixed(2));
      return updatetotalBet;
    });
  };

  const resetMo = (index) => {
    setMoData((prevState) => {
      const updatedMoData = [...prevState];
      updatedMoData[index] = {
        gameName: "",
        position: "",
        numberInput: "",
        sendName: "",
      };
      return updatedMoData;
    });
  };

  return (
    <div className="silangkembang_wrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          {/* {device === "Desktop" ? (
            <>
              <div className="silangkembang_heading">
                <h1>SILANG</h1>
              </div>
              <div className="silangkembang_container">
                <table>
                  <thead>
                    <tr>
                      <th>{props.t("no.")}</th>
                      <th>{props.t("guess")}</th>
                      <th>{props.t("Kei")} (%)</th>
                      <th>
                        {props.t("buy")}{" "}
                        <span className="small_input">1=1000</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className={"even-row"}>
                      <td>1</td>
                      <td>{props.t("front")}</td>
                      <td>
                        {betDiscount.kei_silang_depan
                          ? `${betDiscount.kei_silang_depan}%`
                          : "-"}
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="silangDepan"
                          value={inputs.silangDepan}
                          onChange={handleInputChange}
                          placeholder="1 = 1,000 IDR"
                        />
                      </td>
                    </tr>
                    <tr className={"odd-row"}>
                      <td>2</td>
                      <td>{props.t("middle")}</td>
                      <td>
                        {betDiscount.kei_silang_tengah
                          ? `${betDiscount.kei_silang_tengah}%`
                          : "-"}
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="silangTengah"
                          value={inputs.silangTengah}
                          onChange={handleInputChange}
                          placeholder="1 = 1,000 IDR"
                        />
                      </td>
                    </tr>
                    <tr className={"even-row"}>
                      <td>3</td>
                      <td>{props.t("behind")}</td>
                      <td>
                        {betDiscount.kei_silang_belakang
                          ? `${betDiscount.kei_silang_belakang}%`
                          : "-"}
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="silangBelakang"
                          value={inputs.silangBelakang}
                          onChange={handleInputChange}
                          placeholder="1 = 1,000 IDR"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                className="silangkembang_heading"
                style={{ marginTop: "10px" }}
              >
                <h1>HOMO</h1>
              </div>
              <div className="silangkembang_container">
                <table>
                  <thead>
                    <tr>
                      <th>{props.t("no.")}</th>
                      <th>{props.t("pilihan")}</th>
                      <th>{props.t("Kei")} (%)</th>
                      <th>{props.t("bet")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className={"even-row"}>
                      <td>1</td>
                      <td>{props.t("front")}</td>
                      <td>
                        {betDiscount.kei_homo_depan
                          ? `${betDiscount.kei_homo_depan}%`
                          : "-"}
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="homoDepan"
                          value={inputs.homoDepan}
                          onChange={handleInputChange}
                          placeholder="1 = 1,000 IDR"
                        />
                      </td>
                    </tr>
                    <tr className={"odd-row"}>
                      <td>2</td>
                      <td>{props.t("middle")}</td>
                      <td>
                        {betDiscount.kei_homo_tengah
                          ? `${betDiscount.kei_homo_tengah}%`
                          : "-"}
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="homoTengah"
                          value={inputs.homoTengah}
                          onChange={handleInputChange}
                          placeholder="1 = 1,000 IDR"
                        />
                      </td>
                    </tr>
                    <tr className={"even-row"}>
                      <td>3</td>
                      <td>{props.t("behind")}</td>
                      <td>
                        {betDiscount.kei_homo_belakang
                          ? `${betDiscount.kei_homo_belakang}%`
                          : "-"}
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="homoBelakang"
                          value={inputs.homoBelakang}
                          onChange={handleInputChange}
                          placeholder="1 = 1,000 IDR"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          ) : ( */}
          <div className="container" style={{ flexDirection: "column" }}>
            {/* {device === "Mobile" && ( */}
            <CommonBetHeader
              rowsToShow={null}
              handleRowsToShowChange={null}
              bbPayAmount={bbPayAmount}
              totalBetAmount={totalBetAmount}
              changeText={"Silang Homo"}
            />
            {/* )} */}
            <table className="silang-table tbl_3">
              <thead>
                <tr className="">
                  <th style={{ width: device === "Mobile" ? "80px" : "200px" }}>
                    {props.t("position")}
                  </th>
                  <th style={{ padding: 0, paddingRight: "2px" }}>
                    <table
                      className="data-table"
                      width={"100%"}
                      style={{ border: 0 }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              width: device === "Mobile" ? "80px" : "350px",
                            }}
                          >
                            {props.t("guess")}
                          </th>
                          <th>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                              }}
                            >
                              <span
                                style={{
                                  width: "53px",
                                  padding: "0 10px",
                                  background: "none",
                                  border: "none",
                                }}
                              >
                                {props.t("Kei")}
                              </span>
                              <input
                                id="inputs"
                                type="text"
                                inputMode="decimal"
                                pattern="[0-9]*[.,]?[0-9]**"
                                autoComplete="off"
                                placeholder="Auto Bet"
                                value={defaultValue ? defaultValue : ""}
                                onChange={(e) => handleDeafultInputChange(e)}
                                onBlur={(e) => handleDeafultInputBlur(e)}
                                style={{ padding: "5px 0px" }}
                              />
                            </div>
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </th>
                </tr>
              </thead>
              <tbody>
                {mainGroup.map((item, index) => (
                  <tr
                    key={index}
                    className={`form-input-row ${index % 2 === 0 ? "even-row" : "odd-row"
                      }`}
                  >
                    <td className="form-input-row odd-row">{item}</td>
                    <td style={{ padding: "0" }}>
                      <table border="0" style={{ border: "none" }}>
                        <tbody>
                          {moData.map(
                            (val, ind) =>
                              item === val.gameName && (
                                <tr
                                  key={ind}
                                  className={
                                    Math.floor(ind / 3) % 2 === 0
                                      ? "silang-table tbl_2"
                                      : "bg-color-odd"
                                  }
                                >
                                  <td
                                    style={{
                                      width:
                                        device === "Mobile" ? "80px" : "350px",
                                    }}
                                  >
                                    {val.position}
                                  </td>
                                  <td>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <span
                                        className="shilang-bgth"
                                        style={{
                                          width: "50px",
                                          padding: "0 10px",
                                          background: "none",
                                          border: "none",
                                        }}
                                      >
                                        {" "}
                                        {
                                          betDiscount[
                                          keiArrayKeys[val.sendName]
                                          ]
                                        }
                                      </span>
                                      <input
                                        className="inputs"
                                        // disabled={item.gameName === "" || item.position === ""}
                                        type="text"
                                        placeholder="Bet"
                                        value={
                                          val.numberInput !== ""
                                            ? val.numberInput
                                            : ""
                                        }
                                        inputMode="decimal"
                                        pattern="[0-9]*[.,]?[0-9]**"
                                        onChange={(event) =>
                                          handleNumberInputChange(
                                            ind,
                                            event,
                                            keiArrayKeys[val.sendName]
                                          )
                                        }
                                        onFocus={(event) =>
                                          handleNumberInputFocus(
                                            ind,
                                            event,
                                            keiArrayKeys[val.sendName]
                                          )
                                        }
                                        onBlur={(event) =>
                                          handleInputBlur(
                                            ind,
                                            event,
                                            keiArrayKeys[val.sendName]
                                          )
                                        }
                                      />
                                    </div>
                                  </td>
                                </tr>
                              )
                          )}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <table>
              {/* <thead>
                  <tr>
                    <th>{props.t("no.")}</th>
                    <th>{props.t("position")}</th>
                    <th>{props.t("guess")}</th>
                    <th>{props.t("Kei")}</th>
                    <th>
                      {props.t("buy")}
                      <span className="small_input">1=1000</span>
                    </th>
                    <th style={{ whiteSpace: "nowrap" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {moData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td className="inputs">
                        <select
                          value={item.gameName}
                          onChange={(event) =>
                            handlegameNameChange(index, event, "First")
                          }
                        >
                          <option value=""></option>
                          <option value="Silang">Silang</option>
                          <option value="Homo">HOMO</option>
                        </select>
                      </td>
                      <td className="inputs">
                        <select
                          value={item.position}
                          onChange={(event) =>
                            handlegameNameChange(index, event, "Second")
                          }
                        >
                          <option value=""></option>
                          <option value="Depan">{props.t("front")}</option>
                          <option value="Tengah">{props.t("middle")}</option>
                          <option value="Belakang">{props.t("behind")}</option>
                        </select>
                      </td>
                      <td style={{ padding: "0 15px" }}>
                        {item.sendName === "Silang-Depan" ? (
                          <input
                            type="text"
                            value={
                              betDiscount.kei_silang_depan
                                ? betDiscount.kei_silang_depan + "%"
                                : ""
                            }
                            readOnly
                          />
                        ) : item.sendName === "Silang-Tengah" ? (
                          <input
                            type="text"
                            value={
                              betDiscount.kei_silang_tengah
                                ? betDiscount.kei_silang_tengah + "%"
                                : ""
                            }
                            readOnly
                          />
                        ) : item.sendName === "Silang-Belakang" ? (
                          <input
                            type="text"
                            value={
                              betDiscount.kei_silang_belakang
                                ? betDiscount.kei_silang_belakang + "%"
                                : ""
                            }
                            readOnly
                          />
                        ) : item.sendName === "Homo-Depan" ? (
                          <input
                            type="text"
                            value={
                              betDiscount.kei_homo_depan
                                ? betDiscount.kei_homo_depan + "%"
                                : ""
                            }
                            readOnly
                          />
                        ) : item.sendName === "Homo-Tengah" ? (
                          <input
                            type="text"
                            value={
                              betDiscount.kei_homo_tengah
                                ? betDiscount.kei_homo_tengah + "%"
                                : ""
                            }
                            readOnly
                          />
                        ) : item.sendName === "Homo-Belakang" ? (
                          <input
                            type="text"
                            value={
                              betDiscount.kei_homo_belakang
                                ? betDiscount.kei_homo_belakang + "%"
                                : ""
                            }
                            readOnly
                          />
                        ) : (
                          <input
                            type="text"
                            value={
                              betDiscount.kei_silang_depan
                                ? betDiscount.kei_silang_depan + "%"
                                : ""
                            }
                            readOnly
                          />
                        )}
                      </td>
                      <input
                        disabled={item.gameName === "" || item.position === ""}
                        type="text"
                        placeholder="1 = 1,000 IDR"
                        value={item.numberInput}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        onChange={(event) =>
                          handleNumberInputChange(index, event)
                        }
                      />
                      <td>
                        <button
                          className="reset-button"
                          onClick={() => resetMo(index)}
                        >
                          reset
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody> */}
            </table>
          </div>
          {/* )} */}
          <div className="last_div">
            <div className="left_div">
              <p>{props.t("silang_kembang_silang_text")}</p>
            </div>
            <div className="right_div">
              <ul className="button-list">
                <li>
                  <button className="reset" onClick={handleReset}>
                    {props.t("Reset")}
                  </button>
                </li>
                <li>
                  <button className="submit" onClick={submitProcess}>
                    {props.t("submit")}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}

      {
        /*---error popup --*/
        showErrorPopup && (
          <ErrorInnerPopup
            modalTitle={""}
            modalHeader={true}
            onCloseModal={() => setShowErrorPopup(false)}
          >
            <ErrorPopup
              message={errMessage}
              onClose={() => setShowErrorPopup(false)}
            />
          </ErrorInnerPopup>
        )
      }

      {submitPopup && (
        <SilangPopup onClose={closeSubmitPopup} submitResult={submitResult} />
      )}

      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={hanldeConfirmationPopupClose}
          submitProcessOk={submitSilang}
        />
      )}
      {showCancelledPopup && (
        <CancelledBetDeskonPopup onClose={() => setShowCanclledPopup(false)} />
      )}
    </div>
  );
};

export default withTranslation()(Silang);
